import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Page from "./pages/Page";
import { PrivacyPolicy, TermsOfService, CookiePolicy } from "./pages/LegalPages";
import {
  HOMEPAGE_SECTIONS,
  SERVICES_PAGE_SECTIONS,
  BENEFIT_PAGE_SECTIONS,
  ELDERLY_PAGE_SECTIONS,
  ABOUT_PAGE_SECTIONS,
  PRICING_PAGE_SECTIONS,
  CONTACT_PAGE_SECTIONS,
} from "./lib/site";
import "./index.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Page path="/" sections={HOMEPAGE_SECTIONS} />} />
        <Route path="/services" element={<Page path="/services" sections={SERVICES_PAGE_SECTIONS} />} />
        <Route path="/benefit-application-help" element={<Page path="/benefit-application-help" sections={BENEFIT_PAGE_SECTIONS} />} />
        <Route path="/elderly-support" element={<Page path="/elderly-support" sections={ELDERLY_PAGE_SECTIONS} />} />
        <Route path="/about" element={<Page path="/about" sections={ABOUT_PAGE_SECTIONS} />} />
        <Route path="/pricing" element={<Page path="/pricing" sections={PRICING_PAGE_SECTIONS} />} />
        <Route path="/contact" element={<Page path="/contact" sections={CONTACT_PAGE_SECTIONS} />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="*" element={<Page path="/" sections={HOMEPAGE_SECTIONS} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
